import React, { useState } from "react";
import { Box, Typography, useMediaQuery } from "@mui/material";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";

interface SpecificationLightboxProps {
  projectTitle?: string | null;
}

const SpecificationLightbox: React.FC <SpecificationLightboxProps> = ({ projectTitle }) => {
const [isOpen, setIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);

  const isMobile = useMediaQuery("(max-width: 600px)");

  const isVibrante = !!projectTitle && projectTitle.toLowerCase().includes("vibrant");

  const desktopImages = [
    "https://dprstorage.b-cdn.net/RW/projects/spec1.png",
    "https://dprstorage.b-cdn.net/RW/projects/spec2.png",
    "https://dprstorage.b-cdn.net/RW/projects/spec3.png"
  ];

  const mobileImages = [
    "https://dprstorage.b-cdn.net/RW/projects/sm1.png",
   "https://dprstorage.b-cdn.net/RW/projects/spcm2.png",
   "https://dprstorage.b-cdn.net/RW/projects/specm3.png",
   "https://dprstorage.b-cdn.net/RW/projects/spec4.png",
   "https://dprstorage.b-cdn.net/RW/projects/spcm5.png"
  ];

  const images = isMobile ? mobileImages : desktopImages;

  if (!isVibrante) return null;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        mt: 0,
        mb: 5,
        // zIndex: 1000000,
      }}
    >
      <Box maxWidth='md'>

        <Box
          sx={{
            width: { xs: "100%", sm: "62%", md: "255px" },
            maxWidth: "260px",
            cursor: "pointer",
            zIndex:10,
            background: "white",
            borderRadius: "12px",
            padding: { xs: "10px", md: "16px" },
            boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)",
            border: "1px solid rgb(0, 0, 0)",
            transition: "transform 0.3s ease, box-shadow 0.3s ease",
            "&:hover": {
              transform: "scale(1.02)",
              boxShadow: "0px 8px 25px rgba(0, 0, 0, 0.3)",
            },
          }}
          onClick={() => setIsOpen(true)}
        >
          <Typography
            variant="h2"
            sx={{
              fontWeight: "600",
              fontSize: { xs: "18px", sm: "22px", md: "26px" },
              color: "#0f63a5",
              textAlign: "center",
            }}
          >
            Specifications
          </Typography>

          <Typography
            variant="body1"
            sx={{
              fontSize: { xs: "10px", sm: "12px", md: "14px" },
              fontFamily: "LEMON MILK",
              color: "#0f63a5",
              fontWeight: "400",
              mt: 0.5,
              textDecoration: "none",
              "&:hover": { textDecoration: "underline" },
              textAlign: "center",
            }}
          >
            Tap to View
          </Typography>
        </Box>
        <Box
        maxWidth='md'
          sx={{
              py:4,
              zIndex:10
            }}
        >

          {isOpen && (
            <Lightbox
            
              mainSrc={images[photoIndex]}
              nextSrc={images[(photoIndex + 1) % images.length]}
              prevSrc={images[(photoIndex + images.length - 1) % images.length]}
              onCloseRequest={() => setIsOpen(false)}
              onMovePrevRequest={() =>
                setPhotoIndex((photoIndex + images.length - 1) % images.length)
              }
              onMoveNextRequest={() =>
                setPhotoIndex((photoIndex + 1) % images.length)
              }
            />
          )}

        </Box>
      </Box>
    </Box>
  );
};

export default SpecificationLightbox;
